import type { PublicVideoRequest } from 'apollo-gql'

import { VideoRequestBookAgainClickedProperties } from '../sdk'

const getVideoRequestAnalyticsProperties = (
  request: PublicVideoRequest,
): Omit<VideoRequestBookAgainClickedProperties, 'marketId' | 'localeId'> => ({
  requestId: request.id,
  requestShortId: request.shortId,
  requestRequestType: request.requestType,
  requestOccasionInternalName: request?.requestOccasion?.internalName || null,
  requestToPronoun: request?.toPronoun || null,
  requestIsGift: request.isGift,
  requestFromPronoun: request?.fromPronoun || null,
  requestVideoPrivateByCustomer: request.videoPrivateByCustomer,
  requestWatermarkedVideo:
    !request?.videoRequestTags?.some(({ id }) => id === 'NO_WATERMARK') || null,
  requestVideoQuality: null,
  requestVideoMinLengthSeconds: null,
  requestExpirationTime: null,
  requestStatus: null,
  requestExpiresAt: null,
  requestVideoPrivateByProfile: null,
})

export default getVideoRequestAnalyticsProperties
